import * as React from "react";
import { SelectEditor } from "../../../../../react-core/Html/SelectEditor";
import { LiteratureLibraryClient } from "../../../../../Wrap/Api/Documents/LiteratureLibrary";
import { Category } from "../../../../../Wrap/Constants/Enums/Documents/Category";
import { FavouritesToggle } from "../../../../Shared/IST/Components/Shared/FavouritesToggle";
import { SearchInput } from "../../../../Shared/SearchInput/SearchInput";
import { Table } from "../../../../Shared/Table/Table";
import { LiteratureAction } from "../Action/LiteratureAction";
import { DocTypeArray, DocTypeMap, literatureCoachmarkerConfig } from "../Resource/Content";
import { groupBy } from "lodash";
import { LiteratureLibrary } from "../../../../../Wrap/Models/Models/Documents/LiteratureLibrary";
import { Alert } from "../../../../Shared/Components/Alert";
import { AlertType } from "../../../../Shared/Entities/Constants/AlertConstants";
import CoachMarker from "../../../../Shared/CoachMarkers/CoachMarker";
import { CoachMarkerContext } from "../../../../Shared/CoachMarkers/CoachMarkerContext";
import AdviserSiteTagManager from "../../../../Shared/Cookies/ChoicesCookie/AdviserSiteTagManager";
import { UserStore } from "../../../Stroes/Variable";
import { JsonDateParser } from "../../../../../react-core/Utils/JsonDateParser";

export const Literature = () => {
    const [docType, setDocType] = React.useState(Category.NotSpecified);
    const [isFavourite, setIsFavourite] = React.useState(false);
    const [data, setData] = React.useState(null);

    const { setPageConfig } = React.useContext(CoachMarkerContext);

    const { addEvent } = new AdviserSiteTagManager();

    React.useEffect(() => {
        addEvent({
            environment: {
                appType: "web",
                setting: "prod",
                timestamps: JsonDateParser.toJsonDateNoOffset(new Date()).toString(),
            },
            page: {
                pageUrl: window.location.pathname.includes("literature")
                    ? window.location.pathname
                    : window.location.pathname + "/literature",
                pageTitle: `${document.title} - tools and literature - literature`,
            },
            user: {
                loginId: UserStore.getUserInfo()?.ClientId.toString(),
                internal: "yes",
            },
            event: "pageLoaded",
        });
    }, []);

    React.useEffect(() => {
        // Setup Coachmarks for this page
        //setPageConfig(literatureCoachmarkerConfig);
        return () => {
            setPageConfig(null);
        };
    }, []);

    React.useEffect(() => {
        LiteratureAction.searchDoc("", docType, isFavourite, (d) => setData(d));
    }, []);

    const renderTable = (data, Category) => {
        const categoryName = Category == "Guiding" ? "Guides" : Category;
        return (
            <>
                <h2>{categoryName}</h2>
                <Table
                    data={data}
                    showEmptyMsg
                    col={[
                        {
                            title: "Document name",
                            key: "Description",
                            tdCssWrapper: "cell-70",
                            thCssWrapper: "cell-70",
                            render: (rowData, row: LiteratureLibrary, index) => {
                                return (
                                    <FavouritesToggle
                                        cssWrapper="in-table"
                                        label={
                                            <a
                                                className={"hyperlink"}
                                                onClick={() =>
                                                    window.open(
                                                        `/popups/loaddocstore.aspx?filename=${row.FileName}&encrypt=yes`,
                                                        "_blank"
                                                    )
                                                }
                                            >
                                                {rowData}
                                            </a>
                                        }
                                        onToggle={(v) => {
                                            LiteratureAction.setFavourite(parseInt(row.ID), v);
                                            const _data = JSON.parse(JSON.stringify(data));
                                            const product = _data.find((ele) => ele.ID == row.ID);
                                            product.IsFavourite = v;
                                            setData(_data);
                                        }}
                                        isFavourite={row.IsFavourite}
                                        key={rowData}
                                    />
                                );
                            },
                        },
                        {
                            title: "Document code",
                            key: "DocumentCode",
                            tdCssWrapper: "cell-30",
                            thCssWrapper: "cell-30",
                        },
                    ]}
                />
            </>
        );
    };

    const client = new LiteratureLibraryClient();
    const groupData = groupBy(data, "Category");
    return (
        <>
            <SearchInput
                cssWrapper="control-size-430"
                apiClient={(v) => {
                    return client.get(v, docType, isFavourite ? isFavourite : null);
                }}
                onClick={(v) => {
                    if (v) {
                        setData([v]);
                    }
                }}
                getText={(o) => o.Description}
                label="Search"
                placeholder="Search for document by name or code"
            />
            <SelectEditor
                options={DocTypeArray}
                cssWrapper="control-size-430 mb-0"
                getText={(o) => DocTypeMap[o]}
                onChange={(v) => {
                    setDocType(v);
                    LiteratureAction.searchDoc("", v, isFavourite, (d) => setData(d));
                }}
                label="Document type"
            />
            <div className="row row-right mb-8">
                <div className="col-auto">
                    <CoachMarker coachMarkerKey="literature-favourites" />
                    <FavouritesToggle
                        label={"Favourites"}
                        isFavourite={isFavourite}
                        onToggle={() => {
                            setIsFavourite(!isFavourite);
                            LiteratureAction.searchDoc("", docType, !isFavourite, (d) => setData(d));
                        }}
                    />
                </div>
            </div>
            {/* {isFavourite && SectionHeader("Favourites")} */}
            {data && data.length == 0 && (
                <Alert
                    alertType={AlertType.Warning}
                    message={"No documents have been found for the entered criteria."}
                />
            )}
            {data &&
                Object.keys(groupData).map((key) => {
                    return renderTable(groupData[key], key);
                })}
        </>
    );
};
